import { useNavigate } from "react-router-dom";
import { Camera, Sparkles, ShieldCheck } from "lucide-react";

export default function Landing() {
  const navigate = useNavigate();
  return (
    <div className="px-6 pt-6" data-testid="landing-page">
      <div className="mm-card mb-6" data-testid="hero-card">
        <div className="mm-label mb-2">Marketplace pricing tool</div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900 leading-[1.1]">
          Know What Your Item Is Worth
        </h1>
        <p className="mt-4 text-slate-600 text-base leading-relaxed">
          Take a photo and get a recommended resale price based on similar
          products and current market data.
        </p>

        <div className="grid grid-cols-2 gap-3 mt-6">
          <div className="rounded-2xl bg-slate-50 border border-slate-200 p-3">
            <Sparkles className="text-blue-700 mb-2" size={18} strokeWidth={2.5} />
            <div className="text-xs font-bold text-slate-900">
              Snap. Analyze.
            </div>
            <div className="text-xs text-slate-500 mt-1">
              Prices in under a minute
            </div>
          </div>
          <div className="rounded-2xl bg-slate-50 border border-slate-200 p-3">
            <ShieldCheck className="text-blue-700 mb-2" size={18} strokeWidth={2.5} />
            <div className="text-xs font-bold text-slate-900">
              Ready-to-post
            </div>
            <div className="text-xs text-slate-500 mt-1">
              Title & description included
            </div>
          </div>
        </div>
      </div>

      <div className="mm-card" data-testid="how-it-works">
        <div className="mm-label mb-4">How it works</div>
        <ol className="space-y-3 text-sm text-slate-700">
          {[
            "Take a clear photo of your item",
            "Answer a few short questions",
            "Get three price options + a ready-to-post listing",
          ].map((step, i) => (
            <li key={i} className="flex items-start gap-3">
              <span className="font-mono font-bold text-blue-700 w-6 h-6 rounded-full bg-blue-50 grid place-items-center text-xs">
                {i + 1}
              </span>
              <span>{step}</span>
            </li>
          ))}
        </ol>
      </div>

      <div className="mm-fixed-cta">
        <button
          className="mm-btn-primary"
          onClick={() => navigate("/scan")}
          data-testid="take-photo-btn"
        >
          <Camera size={22} strokeWidth={2.5} />
          Take a Photo
        </button>
        <p className="text-center text-xs text-slate-500 mt-3">
          Your first 2 item scans are free. No credit card required.
        </p>
      </div>
    </div>
  );
}
